export default __webpack_public_path__ + "static/media/Gpay.603ee42d.svg";